export default __webpack_public_path__ + "static/media/volunteer-faq.47749168.jpg";